import { List, styled, useTheme } from "@mui/material";

export const ActionsList = styled(List)(({ theme }) => ({
  "& li:not(:last-child)": { borderBottom: `1px solid ${theme.palette.divider}`, borderTop: "none" },
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.default,
  padding: 0,
}));
